import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { ApplicationForm } from '../components/landing/ApplicationForm'
import { Footer } from '../components/landing/Footer'
import { Header } from '../components/landing/Header'

const applySearchSchema = z.object({
    programId: z.string().optional(),
    eventId: z.string().optional(),
    eventPackageId: z.string().optional(),
})

function ApplyPage() {
    const { programId, eventId, eventPackageId } = Route.useSearch()

    return (
        <div className="min-h-screen bg-off-white font-sans text-brand-dark">
            <Header />
            <main>
                <section className="relative overflow-hidden bg-off-white py-24">
                    <div className="absolute -right-40 -top-40 h-96 w-96 rounded-full bg-brand-yellow/10 blur-[120px]" />
                    <div className="absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-primary/10 blur-[120px]" />

                    <div className="relative mx-auto max-w-[800px] px-6">
                        <div className="mb-16 text-center">
                            <div className="mb-6 inline-block rounded-full bg-brand-yellow px-4 py-1 text-[10px] font-bold uppercase tracking-widest text-brand-dark">
                                Jelentkezés
                            </div>
                            <h1 className="mb-6 text-4xl font-bold leading-tight text-brand-dark md:text-6xl">
                                Jelentkezzen programjainkra
                                <br />
                                <span className="text-primary">és eseményeinkre</span>
                            </h1>
                            <p className="mx-auto max-w-xl text-lg leading-relaxed text-brand-gray">
                                Töltse ki az alábbi űrlapot, és hamarosan felvesszük Önnel a
                                kapcsolatot.
                            </p>
                        </div>

                        <ApplicationForm
                            programId={programId}
                            eventId={eventId}
                            eventPackageId={eventPackageId}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export const Route = createFileRoute('/apply')({
    head: () => ({
        meta: [{ title: 'Long-Y - Jelentkezés' }],
    }),
    component: ApplyPage,
    validateSearch: applySearchSchema,
    loader: async ({ context }) => {
        await Promise.all([
            context.apiUtils.lifestyleProgram.getPublicList.ensureData(),
            context.apiUtils.event.getPublicEvents.ensureData(),
            context.apiUtils.webContent.getAllPublic.ensureData(),
        ])
    },
})
